import { AxiosError } from 'axios'

import { GenericErrors } from './types'

export * from './types'
export * from './utils'
export * from './Request'

// get errors from axios response and display toast unless its is 400 response then return errors
const defaulErrorMessages = {
  message404: 'Taka strona nie istnieje',
  messge403: 'Nie masz dostępu do tej strony',
  messageNoResponse: 'Nie można połączyć się z serwerem. Spróbuj ponownie',
}

// TODO
export const get400ErrorsFormik = (err: AxiosError) => {
  const errors = get400Erros(err)
  if (!errors) {
    return {}
  } else {
    const ret = {}

    return ret
  }
}

export const handleErrResponse = (
  err: AxiosError,
  options = defaulErrorMessages,
): GenericErrors => {
  const status = getErrStatus(err)

  if (!status) {
    return handleNoResponse(err, options.messageNoResponse)
  }
  if (status && status === 404) {
    return handle404(err, options.message404)
  }

  if (status && status === 403) {
    return handle403(
      err,
      (err.response as any).data.message || options.messge403,
    )
  }

  if (status && status === 400) {
    return get400Erros(err)
  }

  return []
}

export const transformErrorsForForm = (errors: GenericErrors) => {
  return errors.reduce((prevVal, current) => {
    prevVal[current.property] = current.message
    return prevVal
  }, {})
}

export const handleErrResponseForForm = (err: any, form: any) => {
  handleErrResponse(err)
  const errors = get400Erros(err)
  const errorsForForm = transformForForm(errors, form.getFieldsValue())
  form.setFields(errorsForForm)
}

export const getErrStatus = (err: AxiosError) => {
  return err.response && err.response.status ? err.response.status : null
}

export const handleNoResponse = (
  err: AxiosError,
  msg = 'Nie można połączyć się z serwerem. Spróbuj ponownie',
): GenericErrors => {
  return [
    {
      property: 'server',
      message: msg,
    },
  ]
}

export const handle404 = (
  err: AxiosError,
  msg = 'Taki zasób nie istnieje',
): GenericErrors => {
  return [
    {
      property: 'id',
      message: msg,
    },
  ]
}

export const handle403 = (
  err: AxiosError,
  msg = 'Nie masz dostępu do tego zasobu',
): GenericErrors => {
  return [
    {
      property: 'auth',
      message: msg,
    },
  ]
}

export const get400Erros = (err: AxiosError): GenericErrors => {
  if (
    err.response &&
    err.response.data &&
    err.response.data['violations'] !== undefined &&
    Array.isArray(err.response.data.violations)
  ) {
    return err.response.data.violations.map(el => ({
      property: el.propertyPath || 'unknown propertyPath',
      message: el.message || 'unknown message',
    }))
  }

  if (
    err.response &&
    err.response.data &&
    err.response.data['errors'] !== undefined
  ) {
    if (Array.isArray(err.response.data.errors)) {
      return err.response.data.errors
    }
    if (
      err.response.data.errors.type &&
      err.response.data.errors.type == 'https://symfony.com/errors/validation'
    ) {
      return err.response.data.errors.violations
    }
    return err.response.data.errors
  }
  if (err.response && err.response.data) {
    const isArray = Array.isArray(err.response.data)
    if (isArray) {
      const messageArray = err.response.data
      return messageArray.map(el => {
        // tylko pierwszy error
        const constraints = el.constraints
          ? parseConstraints(el.constraints)
          : false
        if (!constraints) {
          return []
        }
        return {
          property: el.property ? el.property : 'unknownProperty',
          message: constraints[0] || 'Unknown message',
        }
      })
    } else {
      // postac pojedynczego error, nie ma tablicy
      const parsed = parseConstraints(err.response.data.message[0].constraints)
      // zwracamy dla wygody tylko pierwszy error dla tego pola
      const constraints = parsed ? parsed[0] : []
      return [
        {
          property: err.response.data.message[0].property
            ? err.response.data.message[0].property
            : 'unknownProperty',
          message: err.response.data.message[0].constraints
            ? constraints
            : 'Unknown message',
        },
      ]
    }
  } else {
    return []
  }
}

export const transformForForm = (errors: any[], data: any) => {
  const ret = {}
  errors.map(el => {
    if (!ret[el.property]) {
      ret[el.property] = {
        value: data[el.property],
        errors: [new Error(el.message)],
      }
    } else {
      ret[el.property].errors.push(new Error(el.message))
    }
  })
  // console.log(ret)
  return ret
}
const parseConstraints = (constraints: any[]) => {
  if (!constraints) {
    return false
  }
  const messages = Object.values(constraints)
    .map(val => val)
    .filter(val => val)

  return messages
}
